// Shared marketing footer. Plain anchors — full-page navigation, matching the
// rest of the public surface.
const COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'How it Works', href: '/#how' },
      { label: 'Pricing',      href: '/#pricing' },
    ],
  },
  {
    title: 'Programs',
    links: [
      { label: 'Affiliate Program', href: '/affiliate' },
      { label: 'Start Free Lessons', href: '/registration' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About',   href: '#' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Privacy Policy',   href: '/privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="site-ftr">
      <div className="site-ftr-inner">
        <div className="site-ftr-brand">
          <a href="/" aria-label="AdaptOS home">
            <img src="/logo.jpg" alt="AdaptOS" />
          </a>
          <p>© 2026 Ahzami Management.<br />All rights reserved.</p>
        </div>

        <div className="site-ftr-cols">
          {COLUMNS.map(col => (
            <div key={col.title} className="site-ftr-col">
              <h4>{col.title}</h4>
              {col.links.map(l => (
                <a key={l.label} href={l.href}>{l.label}</a>
              ))}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .site-ftr {
          background: #1a1a24;
          border-top: 1px solid rgba(255,255,255,0.08);
          padding: clamp(40px, 6vw, 64px) clamp(16px, 4vw, 40px) 40px;
        }
        .site-ftr-inner {
          max-width: 1200px; margin: 0 auto;
          display: flex; flex-wrap: wrap; gap: clamp(32px, 6vw, 80px);
          justify-content: space-between;
        }
        .site-ftr-brand { display: flex; flex-direction: column; gap: 16px; max-width: 280px; }
        .site-ftr-brand img { height: 88px; width: auto; object-fit: contain; display: block; }
        .site-ftr-brand p {
          color: rgba(255,255,255,0.5); font-size: 13px; line-height: 1.6; margin: 0;
        }
        .site-ftr-cols {
          display: flex; flex-wrap: wrap; gap: clamp(28px, 5vw, 56px);
        }
        .site-ftr-col { display: flex; flex-direction: column; gap: 12px; min-width: 130px; }
        .site-ftr-col h4 {
          color: #ffffff; font-size: 13px; font-weight: 700;
          text-transform: uppercase; letter-spacing: .08em; margin: 0 0 4px;
        }
        .site-ftr-col a {
          color: rgba(255,255,255,0.6); text-decoration: none;
          font-size: 14px; transition: color .18s ease;
        }
        .site-ftr-col a:hover { color: #d97706; }
        @media (max-width: 640px) {
          .site-ftr-inner { flex-direction: column; gap: 36px; }
          .site-ftr-cols { gap: 32px 40px; }
          .site-ftr-brand img { height: 72px; }
        }
      `}</style>
    </footer>
  );
}
